import { WMS_PBF_PEMBELIAN } from "App/constants";
import { isNull } from "App/utils/helpers";
import React, { createContext, useEffect, useRef, useState } from "react";
import { FORM_RESET_STATE_WMS_PEMBELIAN } from "../helpers";

export const FormContext = createContext();

export const FormProvider = ({ data, children, menu }) => {
  const oldFormData = useRef(null);
  const [formError, setFormError] = useState(null);

  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return FORM_RESET_STATE_WMS_PEMBELIAN;
    } else {
      if (menu === WMS_PBF_PEMBELIAN) {
        oldFormData.current = data;
        return data;
      } else {
        if (isNull(oldFormData.current)) {
          return FORM_RESET_STATE_WMS_PEMBELIAN;
        } else {
          return oldFormData.current;
        }
      }
    }
  });

  useEffect(() => {
    if (isNull(data)) {
      setFormData(FORM_RESET_STATE_WMS_PEMBELIAN);
    } else {
      if (menu === WMS_PBF_PEMBELIAN) {
        oldFormData.current = data;
        setFormData(data);
      } else {
        if (isNull(oldFormData.current)) {
          setFormData(FORM_RESET_STATE_WMS_PEMBELIAN);
        } else {
          setFormData(oldFormData.current);
        }
      }
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FormContext.Provider
      value={{ formData, setFormData, formError, setFormError }}>
      {children}
    </FormContext.Provider>
  );
};
